import { CapoPlugin } from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];